
export const getPeriodId = (state) => 
	state.context.period ? state.context.period.periodId : null;
